<template>
  <div class="pa-3">
    <v-row
      align="center"
      justify="center"
    >
      <v-col cols="3">
        <v-card>
          <v-card-text>
            <div>Vitajte,</div>
            <p>
              Nachádzate sa v nástrojoch ŠNN
            </p>
            <p>
              Pri používaní tejto aplikácie prosím
              <strong>nepoužívajte</strong> internetový prehliadač Internet
              Explorer, niektoré funkcnie nebudú fungovať korektne. Použite
              napríklad Edge, Chrome, Firefox alebo Operu.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>